import React from 'react'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import { formatLicenceDate, licenceBanner } from '../../../../config/licence'

const EvaluationBanner = ({ licence }) => {
  const { t, i18n } = useTranslation('auth')
  const { kind } = licenceBanner(licence)
  if (kind === 'none') return null

  const date = formatLicenceDate(licence.valid_until, i18n?.language)
  let text
  if (kind === 'invalid') {
    text = t('licence.invalid')
  } else if (kind === 'expired') {
    text = t('licence.expired', { date })
  } else if (kind === 'expiring') {
    text = t('licence.daysLeft', { date, count: licence.days_left })
  } else {
    text = t('licence.active', { date })
  }

  const blocked = kind === 'expired' || kind === 'invalid'
  return (
    <div
      role={blocked ? 'alert' : 'status'}
      data-testid="evaluation-banner"
      data-kind={kind}
      className={clsx('mt-6 px-4 py-3 rounded-xl text-sm border', {
        'bg-red-600/20 border-red-500 text-white': blocked,
        'bg-yellow-500/20 border-yellow-400 text-white': kind === 'expiring',
        'bg-white/10 border-white/30 text-white': kind === 'active',
      })}
    >
      {text}
    </div>
  )
}

export default EvaluationBanner
